module.exports = __webpack_public_path__ + "img/marker_green.a99d0b47.svg";